import Professional from "./ComponentPro"
import Plus from "./ComponentPlus"
import Basic from "./ComponentBase"

function SectionPricing() {
    return (
        <div className=" flex flex-col space-y-8 w-full">
            <h1 className="section">استكشف الباقات.</h1>
            <div className='feature-6 scroll-horizontal flex flex-row space-x-4 overflow-x-scroll no-scrollbar 
                            lg:justify-around' dir="ltr">
                <Professional />
                <Plus />
                <Basic />
            </div>
        </div>
    );
}

export default SectionPricing;